import * as type from '../ActionTypes';

const initialState = {
  timesheet: [],
  milestone: [],
  loading: false,
  savedNewData: false,
  buttonLoading: false,
  error: null,
  editNewData: false,
  editError: null
};

export default function timesheet(state = initialState, action: any) {
  switch (action.type) {
    case type.TIMESHEET_INIT:
      return {
        ...state,
        ...initialState,
        loading: true
      };

    case type.GET_TIMESHEET_REQUEST:
      return {
        ...state,
        loading: true,
        savedNewData: false,
        error: null
      };
    case type.GET_TIMESHEET_SUCCESS:
      return {
        ...state,
        timesheet: action.payload,
        savedNewData: false,
        loading: false
      };
    case type.GET_TIMESHEET_FAILURE:
      return {
        ...state,
        loading: false,
        savedNewData: false,
        error: action.message || 'Oops, something went wrong!'
      };
    case type.POST_TIMESHEET_REQUEST:
      return {
        ...state,
        buttonLoading: true,
        savedNewData: false,
        error: null
      };
    case type.POST_TIMESHEET_SUCCESS:
      return {
        ...state,
        buttonLoading: false,
        savedNewData: true,
        error: null
      };
    case type.POST_TIMESHEET_FAILURE:
      return {
        ...state,
        loading: false,
        savedNewData: false,
        buttonLoading: false,
        error: action.error
      };
    case type.PATCH_TIMESHEET_REQUEST:
      return {
        ...state,
        buttonLoading: true,
        savedNewData: false,
        error: null
      };
    case type.PATCH_TIMESHEET_SUCCESS:
      return {
        ...state,
        buttonLoading: false,
        savedNewData: true,
        error: null
      };
    case type.PATCH_TIMESHEET_FAILURE:
      return {
        ...state,
        loading: false,
        savedNewData: false,
        buttonLoading: false,
        error: action.error
      };
    case type.PUT_TIMESHEET_REQUEST:
      return {
        ...state,
        buttonLoading: true,
        editNewData: false,
        editError: null
      };
    case type.PUT_TIMESHEET_SUCCESS:
      return {
        ...state,
        buttonLoading: false,
        editNewData: true,
        editError: null
      };
    case type.PUT_TIMESHEET_FAILURE:
      return {
        ...state,
        loading: false,
        editNewData: false,
        buttonLoading: false,
        editError: action.error
      };
    case type.GET_MILESTONE_REQUEST:
      return {
        ...state,
        loading: true,
        savedNewData: false,
        error: null
      };
    case type.GET_MILESTONE_SUCCESS:
      return {
        ...state,
        milestone: action.payload,
        loading: false
      };
    case type.GET_MILESTONE_FAILURE:
      return {
        ...state,
        loading: false,
        milestone: [],
        error: action.message // removing this piece of code (|| 'Oops, something went wrong!' ) HAI-108
      };
    case type.POST_MILESTONE_SUCCESS:
      return {
        ...state,
        milestone: action.payload,
        loading: false
      };
    case type.POST_MILESTONE_FAILURE:
      return {
        ...state,
        loading: false,
        milestone: [],
        error: action.error || 'Oops, something went wrong!'
      };
    case type.RESET_TIMESHEET_RESET:
      return {
        ...state,
        loading: false,
        savedNewData: false,
        buttonLoading: false,
        error: null,
        editNewData: false,
        editError: null
      };
    default:
      return state;
  }
}
